import React, { useState } from 'react';
import clsx from 'clsx';
import { Image } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import Star from '@static/images/star.svg';
import styles from './StarRating.module.scss';
const DEFAULT_STAR_COUNT = 5;
/** Rating component using stars. */ export function StarRating({ value, onChange }) {
    const [hoveredIndex, setHoveredIndex] = useState(undefined);
    const displayValue = hoveredIndex != undefined ? hoveredIndex + 1 : value;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container,
        style: {
            '--star-count': DEFAULT_STAR_COUNT
        },
        onMouseLeave: ()=>{
            setHoveredIndex(undefined);
        }
    }, Array.from({
        length: DEFAULT_STAR_COUNT
    }, (_, index)=>{
        const isActive = index < displayValue;
        return /*#__PURE__*/ React.createElement(Image, {
            key: index,
            image: {
                src: Star,
                alt: emptyTranslation
            },
            className: clsx(styles.star, isActive && styles.active),
            onMouseOver: ()=>{
                setHoveredIndex(index);
            },
            onClick: ()=>{
                onChange === null || onChange === void 0 ? void 0 : onChange(index + 1);
            },
            draggable: false
        });
    }));
}
